module.exports = __webpack_public_path__ + "static/media/codropsicons.89060dae.ttf";